var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.3804,
    r: 16,
    fill: "#556EE6",
    fillOpacity: 0.25098
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18.047C17.8384 18.047 19.3334 16.552 19.3334 14.7137C19.3334 12.8754 17.8384 11.3804 16 11.3804C14.1617 11.3804 12.6667 12.8754 12.6667 14.7137C12.6667 16.552 14.1617 18.047 16 18.047ZM16 13.0471C16.9192 13.0471 17.6667 13.7946 17.6667 14.7137C17.6667 15.6329 16.9192 16.3804 16 16.3804C15.0809 16.3804 14.3334 15.6329 14.3334 14.7137C14.3334 13.7946 15.0809 13.0471 16 13.0471Z",
    fill: "#556EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5167 24.5588C15.6617 24.6621 15.8308 24.7138 16 24.7138C16.1692 24.7138 16.3383 24.6621 16.4833 24.5588C16.7367 24.3796 22.6908 20.0805 22.6667 14.7138C22.6667 11.038 19.6758 8.04712 16 8.04712C12.3242 8.04712 9.33333 11.038 9.33333 14.7096C9.30916 20.0805 15.2633 24.3796 15.5167 24.5588ZM16 9.71381C18.7575 9.71381 21 11.9563 21 14.718C21.0175 18.4163 17.3433 21.7371 16 22.8263C14.6575 21.7363 10.9825 18.4146 11 14.7138C11 11.9563 13.2425 9.71381 16 9.71381Z",
    fill: "#556EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/LocationBlue.e1760f0d.svg";
export { ForwardRef as ReactComponent };